export default __webpack_public_path__ + "assets/images/onboarding/f7f66a87e237511e63d9e01169d6b6eb.mp4";